import React from 'react';
import PropTypes from 'prop-types';
import Color from 'color';

import * as defaultStyles from '../styles';
import {deactivateMenu} from '../menu/actions';
import Menu from '../menu/Menu';


const styles = {};

styles.drawer = {
    maxWidth: '2.1rem',
    transition: 'max-width 400ms 500ms, opacity 400ms 500ms',
    overflow: 'hidden',
    opacity: '.6',
    pointerEvents:'auto',
};

styles.hoveredDrawer = {
    ...styles.drawer,
    transition: 'max-width 400ms, opacity 400ms',
    maxWidth: '20rem',
    opacity: 1,
    pointerEvents:'auto',
};


const styleGenerator = (type, props) => {
    switch (type) {
    case 'Component':
    case 'Menu': {
        const style = {
            transition: 'max-width 400ms 500ms, max-height 600ms ease-out',
            overflow: 'hidden',
            paddingRight: 0,
        };
        if (props.active) {
            return {
                ...style,
                transition: 'max-width 400ms, max-height 600ms ease-in 200ms',
                maxWidth: '20rem',
                maxHeight: (props.level || 0) === 0 ? '36rem' : '28rem',
            };
        }
        else
            return {
                ...style,
                maxWidth: '0',
                maxHeight: '0',
            };
    }

    case 'MenuItem': {
        if (props.level === 1) {
            return {
                transition: props.hovered ? 'background-color 400ms' : 'background-color 400ms 500ms',
                display: 'block',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                backgroundColor: props.hovered
                    ? defaultStyles.primaryColor
                    : new Color(defaultStyles.primaryColor).lighten(.5),
                borderTopLeftRadius: '.75rem',
                borderBottomLeftRadius: '.75rem',
                bottomMargin: '.2rem',
                paddingTop: '.7rem',
                paddingBottom: '.7rem',
                paddingLeft: '.3em',
                marginTop: '.2rem',
                marginBottom: '.2rem',
            };
        }
        else {
            return {
                backgroundColor: props.level === 2 ? defaultStyles.thirdColor: 'white',
                paddingTop: '.2rem',
                paddingBottom: '.2rem',
                marginTop: '.4rem',
            };
        }
    }

    case 'MenuItemText':
    case 'MenuText': {
        const style = {
            transition: 'padding 400ms, opacity 400ms',
            color: props.level <= 2 ? 'white' : 'black',
            paddingLeft: '.5rem',
            paddingRight: '.5rem',
            cursor: 'pointer',
            width: `calc(100% - ${Number(props.level) > 1 ? (props.level * .7) + 'rem' : '.2rem'} - 1rem)`,
            boxSizing: 'border-box',
            display: 'inline-block',
        };
        if (!props.hovered) {
            return {
                ...style,
                transition: 'padding 400ms 500ms, opacity 400ms 500ms',
                opacity: 0,
            };
        }
        if (props.level === 1) {
            return {
                ...style,
            };
        }
        return style;
    }

    case 'MenuItemIcon':
    case 'MenuIcon': {
        const style = {
            transition: 'padding 400ms 500ms, width 400ms 500ms',
            width: props.icon ? '1rem' : '0',
            textAlign: 'center',
            color: 'white',
            paddingRight: Number(props.level) > 1 ? (props.level * .7) + 'rem' : '.2rem',
            marginLeft: '.2rem',
            cursor: 'pointer',
        };
        if (props.hovered && props.level === 1) {
            return {
                ...style,
                transition: 'padding 400ms, width 400ms',
                width: '1.5rem',
                paddingRight: '.5rem',
            };
        }
        return style;
    }

    default:
        throw(new Error(`No style for type ${type}`));
    }
};


export default class StickyDrawerMenu extends React.PureComponent {
    static propTypes = {
        activePath: PropTypes.arrayOf(PropTypes.number),
        manualActivePath: PropTypes.arrayOf(PropTypes.number),
        items: PropTypes.arrayOf(PropTypes.object).isRequired,
    }
    static defaultProps = {
        manualActivePath: [],
    }
    static contextTypes = {
        store: PropTypes.object,
    }


    static me = null ;

    static displayMode = '';

    static hide()
    {
        StickyDrawerMenu.displayMode = 'none';
        if(StickyDrawerMenu.me)StickyDrawerMenu.me.setState({rerender:!StickyDrawerMenu.me.state.rerender});
    }

    static show()
    {
        StickyDrawerMenu.displayMode = '';
        if(StickyDrawerMenu.me)StickyDrawerMenu.me.setState({rerender:!StickyDrawerMenu.me.state.rerender});
    }

    state = {
        hovered: false,
        keyboard: ''
    }

    constructor(props) {
        super(props);
        this.mouseEntered = this.mouseEntered.bind(this);
        this.mouseLeft = this.mouseLeft.bind(this);
        StickyDrawerMenu.me = this ;
    }

    componentDidMount() {
        const container = this.refs.drawer;
        if (container.matches(container.tagName + ':hover'))
            this.mouseEntered();
        else
            this.mouseLeft();
    }

    mouseEntered() {
        this.setState({hovered: new Date().getTime()});
    }

    mouseLeft() {
        setTimeout(
            () => {
                if (this.state.hovered < new Date().getTime() -  700) {
                    this.context.store.dispatch(deactivateMenu(this.props.elementId));
                    this.setState({hovered: false});
                }
            },
            700,
        );
    }
    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyPress);
      }
    
      // Remove the event listener
      componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyPress);
      }
    
      // Handle key presses
      handleKeyPress = (event) => {
        switch(event.key){
            case'Control':
                this.setState(e=>({...e, keyboard: 'Control' }));
                 break;
            case 'q':
                this.setState(e=>({...e, keyboard: this.state.keyboard + ' Q' }));
                 break;
          }
        const status = document.getElementById('StickyDrawerMenu-target').style.display;

        if ( this.state.keyboard === 'Control Q' && status !== 'none') {
              document.getElementById('StickyDrawerMenu-target').style.display = 'none';
              this.setState(e=>({...e, keyboard: '' }))
        }else if(this.state.keyboard === 'Control Q'){
            document.getElementById('StickyDrawerMenu-target').style.display = 'block';
            this.setState(e=>({...e, keyboard: '' }))
        }
    }

    render() {
        
        const hovered = this.state.hovered || this.props.manualActivePath.length;
        return <div
            ref='drawer'
            id="StickyDrawerMenu-target"
            style={{display:StickyDrawerMenu.displayMode, pointerEvents:'none', position: 'fixed', top: 0, height: '100%', right: 0, zIndex: 10}}>
            <div style={{display: 'flex', height: '100%', alignItems:'center'}} onClick={this.mouseEntered}>
                <div style={hovered ? styles.hoveredDrawer : styles.drawer}>
                    <div 
                        onMouseEnter={this.mouseEntered}
                        onMouseLeave={this.mouseLeft}>
                        <Menu
                            {...this.props}
                            activePath={this.props.manualActivePath.length > 0
                                ? this.props.manualActivePath
                                : this.props.activePath}
                            active
                            hovered={hovered}
                            style={styleGenerator}
                        />
                    </div>
                </div>
            </div>
        </div>; 
    }
}
